import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-white">
        <div className="label-mono">Checking session…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}
